import { Button, Image, message, Space, Typography } from "antd";
import { useMsal } from "@azure/msal-react";
import { get as _get, isEmpty } from "lodash";
import { loginRequest } from "@utils/azure-ad-sso";
import MicroSoftLogo from "@assets/SVG/microsoft.svg";
import { useNotification } from "@hooks/useNotification";
import axios from "axios";
import { apiBaseUrl } from "~/Services/api.service";
import { useLocalStorage } from "@hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { decodeToken } from "react-jwt";
import { useEffect, useState } from "react";
import { panelApiUrl, reactAuthFlow, UserType } from "~/Utils";
import { UserConsent } from "./UserConsent";
import { useLocation } from "react-router-dom";
import { AuthenticationResult, EventType } from "@azure/msal-browser";

interface Props {
  authFlow: string;
}

export const SignInWithAzureAD = () => {
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useLocalStorage("user", null);
  const [panelUser, setPanelUser] = useLocalStorage("panelUser", null);
  const [xAuthProvider, setxAuthProvider] = useLocalStorage("authProvider", "azure");
  const [openModal, setOpenModal] = useState(false);
  const [imageKey, setImageKey] = useLocalStorage("imageKey", null);
  const [docVersionKey, setDocVersionKey] = useLocalStorage("docVersionKey", null);
  const [consentURL, setConsentURL] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSSOLoading, setIsSSOLoading] = useState(false);
  const [inactivePanelUser, setInactivePanelUser] = useLocalStorage("inactivePanelUser", "false");
  const [inactiveSpaUser, setInactiveSpaUser] = useLocalStorage("inactiveSpaUser", "false");


  useEffect(() => {
    instance.addEventCallback((event: any) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload
      ) {
        setIsSSOLoading(true);
        const response = event.payload as AuthenticationResult;
        // setUser({
        //       email: "subramaniyan.s@mind-graph.com",
        //       refreshToken: "",
        //       token: response.accessToken,
        //       role: "SUPER_ADMIN",
        //     });
        // setIsSSOLoading(false);
        // window.location.pathname = `/dashboard`;
        axios
          .get(`${apiBaseUrl}/v1/user/user-access`, {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
              "X-Auth-Provider": "azure",
            },
          })
          .then(async ({ data }: any) => {
            const tokenDetails: any = decodeToken(response.accessToken);
            let clmData = _get(data, "response.data.clm");
            setxAuthProvider("azure");
            try {
              await axios
                .get(`${panelApiUrl}/user/user-access`, {
                  headers: {
                    Authorization: `Bearer ${response.accessToken}`,
                    "X-Auth-Provider": "azure",
                  },
                })
                .then(({ data }: any) => {
                  const userActive = data?.response?.data?.isActivePanelUser;
                  setPanelUser({
                    email: data.response.data.emailAddress,
                    panelUserName: data.response.data.userName,
                    currentRole: data.response.data.currentRole,
                    token: response.accessToken,
                  });
                  setInactivePanelUser(userActive)
                  /* Panel's documents need Panel's own SAS key, not e-POD's. */
                  localStorage.setItem("panelDocVersionKey", JSON.stringify(data?.response?.data?.docVersionKey ?? null));
                });
            } catch (panelErr) {
              console.error("panelApiUrl user-access call failed", panelErr);
            }
            if (!data.response.data.isSpaUser) {
              setUser({
                email: data.response.data.emailAddress,
                userName: tokenDetails.name,
                token: response.accessToken,
                role: data.response.data.role,
                isMasterAdmin: data?.response?.data?.isMasterAdmin,
              });
              setImageKey(data?.response?.data?.imageKey);
              setDocVersionKey(data?.response?.data?.docVersionKey);
              const queryParams = new URLSearchParams(location.search);
              const redirectTo: any = queryParams.get("redirect");
              if (!isEmpty(redirectTo) && redirectTo?.startsWith("/")) {
                localStorage.removeItem("redirectTo");
                window.location.href = window.location.origin + redirectTo;
              } else {
                window.location.pathname = `/module-selection`;
              }
            } else {
              setUser({
                email: data.response.data.emailAddress,
                userName: tokenDetails.name,
                token: response.accessToken,
                role: data.response.data.role,
                isMasterAdmin: data?.response?.data?.isMasterAdmin,
              });
              setInactiveSpaUser(data?.response?.data?.isActiveSpaUser)
              setImageKey(data?.response?.data?.imageKey);
              setDocVersionKey(data?.response?.data?.docVersionKey);
              const queryParams = new URLSearchParams(location.search);
              const redirectTo: any = queryParams.get("redirect");
              if (!isEmpty(redirectTo) && redirectTo?.startsWith("/")) {
                localStorage.removeItem("redirectTo");
                window.location.href = window.location.origin + redirectTo;
              } else {
                window.location.pathname = `/module-selection`;
              }
            }
            setIsSSOLoading(false);
            // if (data.response && event.interactionType != "silent") {
            //   // if(data.response.data.isActiveClmUser && data.response.data.role == "SUPER_ADMIN"){
            //   //   setUser({
            //   //     email: data.response.data.emailAddress,
            //   //     refreshToken: "",
            //   //     token: response.accessToken,
            //   //     access: data.response.data.access,
            //   //     role: data.response.data.role,
            //   //   });
            //   //   window.location.pathname = `/user-management`;
            //   // }

            //   if (data.response.data.isClmUser && !data.response.data.isActiveClmUser) {
            //     message.error("User has been De - Activated");
            //     setIsSSOLoading(false);
            //     return;
            //   } else if (!(data.response.data.isOnboardedUser && data.response.data.isUserOnboardApproved)) {
            //     console.log(data.response.data.isOnboardedUser, data.response.data.isUserOnboardApproved);
            //     setUser({
            //       email: data.response.data.emailAddress,
            //       refreshToken: "",
            //       token: response.accessToken,
            //       access: data.response.data.access,
            //       role: data.response.data.role,
            //       isRequestedStatus: data.response.data.isUserOnboardApproved,
            //       status: data.response.data.status,
            //     });
            //     window.location.pathname = `/clm/welcome-page`;
            //   } else if (data.response.data.isDocusignRequired) {
            //     if (!data.response.data.isDocusignAccountActivated) {
            //       setIsActive(false);
            //       setOpenModal(true);
            //       setIsSSOLoading(false);
            //     } else if (!data.response.data.isConsentSubmitted) {
            //       sendEmail(response.accessToken);
            //       setConsentURL(clmData.consentUrl);
            //       setOpenModal(true);
            //       setIsSSOLoading(false);
            //     } else if (
            //       data.response.data.isOnboardedUser &&
            //       data.response.data.isDocusignRequired &&
            //       data.response.data.isDocusignAccountActivated &&
            //       data.response.data.isConsentSubmitted
            //     ) {
            //       setUser({
            //         email: data.response.data.emailAddress,
            //         refreshToken: "",
            //         token: response.accessToken,
            //         access: data.response.data.access,
            //         role: data.response.data.role,
            //       });
            //       const queryParams = new URLSearchParams(location.search);
            //       const redirectTo: any = queryParams.get("redirect");
            //       if (!isEmpty(redirectTo) && redirectTo?.startsWith("/")) {
            //         localStorage.removeItem("redirectTo");
            //         window.location.href = window.location.origin + redirectTo;
            //       }
            //       else if (data.response.data.role == "LOA_REVIEWER" || data.response.data.role == "LOA_CREATOR") {
            //         window.location.pathname = `/pcd-dashboard`;
            //       } else if (data.response.data.role == "PCD_ADMIN") {
            //         window.location.pathname = `/pcd-dashboard`;
            //       } else if (data.response.data.role == "COMMERCIAL_ADMIN") {
            //         window.location.pathname = `/commercial-dashboard`;
            //       } else if (
            //         data.response.data.role == "CONTRACT_REVIEWER" ||
            //         data.response.data.role == "CONTRACT_CREATOR"
            //       ) {
            //         window.location.pathname = `/pcd-dashboard`;
            //       } else if (data.response.data.role == "CMU_REVIEWER" || data.response.data.role == "CMU_CREATOR") {
            //         window.location.pathname = `/commercial-dashboard`;
            //       } else if (data.response.data.role == "LOO_REVIEWER" || data.response.data.role == "LOO_CREATOR") {
            //         window.location.pathname = `/commercial-dashboard`;
            //       } else if (data.response.data.role == "TA_REVIEWER" || data.response.data.role == "LOO_CREATOR") {
            //         window.location.pathname = `/commercial-dashboard`;
            //       } else if (data.response.data.role == "SUPER_ADMIN" || data.response.data.role == "PCD_USER") {
            //         window.location.pathname = `/pcd-dashboard`;
            //       } else if (data.response.data.role == "LEGAL_ADMIN" || data.response.data.role == "LEGAL_USER") {
            //         window.location.pathname = `/legal-pcd/dashboard`;
            //       } else {
            //         window.location.pathname = `/dashboard`;
            //       }
            //     }
            //   } else if (!data.response.data.isDocusignRequired) {
            //     setUser({
            //       email: data.response.data.emailAddress,
            //       refreshToken: "",
            //       token: response.accessToken,
            //       access: data.response.data.access,
            //       role: data.response.data.role,
            //     });
            //     const queryParams = new URLSearchParams(location.search);
            //     const redirectTo: any = queryParams.get("redirect");
            //     if (!isEmpty(redirectTo) && redirectTo?.startsWith("/")) {
            //       localStorage.removeItem("redirectTo");
            //       window.location.href = window.location.origin + redirectTo;
            //     }
            //     else if (data.response.data.role == "LOA_REVIEWER" || data.response.data.role == "LOA_CREATOR") {
            //       window.location.pathname = `/pcd-dashboard`;
            //     } else if (data.response.data.role == "PCD_ADMIN") {
            //       window.location.pathname = `/pcd-dashboard`;
            //     } else if (data.response.data.role == "COMMERCIAL_ADMIN") {
            //       window.location.pathname = `/commercial-dashboard`;
            //     } else if (
            //       data.response.data.role == "CONTRACT_REVIEWER" ||
            //       data.response.data.role == "CONTRACT_CREATOR"
            //     ) {
            //       window.location.pathname = `/pcd-dashboard`;
            //     } else if (
            //       data.response.data.role == "CMU_REVIEWER" ||
            //       data.response.data.role == "CMU_CREATOR" ||
            //       data.response.data.role == "COMMERCIAL_USER"
            //     ) {
            //       window.location.pathname = `/commercial-dashboard`;
            //     } else if (data.response.data.role == "LOO_REVIEWER" || data.response.data.role == "LOO_CREATOR") {
            //       window.location.pathname = `/commercial-dashboard`;
            //     } else if (data.response.data.role == "TA_REVIEWER" || data.response.data.role == "LOO_CREATOR") {
            //       window.location.pathname = `/commercial-dashboard`;
            //     } else if (data.response.data.role == "SUPER_ADMIN" || data.response.data.role == "PCD_USER") {
            //       window.location.pathname = `/pcd-dashboard`;
            //     } else if (data.response.data.role == "LEGAL_ADMIN" || data.response.data.role == "LEGAL_USER") {
            //       window.location.pathname = `/legal-pcd/dashboard`;
            //     } else {
            //       window.location.pathname = `/dashboard`;
            //     }
            //   }
            //   setIsSSOLoading(false);
            // }
          })
          .catch(() => {
            setIsSSOLoading(false);
            openToast({ content: "Something went wrong!", type: "error" });
            instance.logout({ account: response.account });
          });
      }
    });
  }, [instance]);

  // const login = () => {
  //   setIsLoading(true);
  //   instance
  //     .loginPopup(loginRequest)
  //     .then((res: any) => {
  //       axios
  //         .get(`${apiBaseUrl}/userprofile/access`, {
  //           headers: {
  //             Authorization: `Bearer ${res.accessToken}`,
  //             "X-Auth-Provider": "azure",
  //           },
  //         })
  //         .then(({ data }: any) => {
  //           const tokenDetails: any = decodeToken(res.accessToken);
  //           let clmData = _get(data, "response.data.clm");
  //           if(!clmData.active){
  //             setIsActive(false)
  //             setOpenModal(true);
  //           }
  //           else  if (clmData.enabled && !clmData.consentGiven) {
  //             // window.open(clmData.consentUrl);
  //             sendEmail(res.accessToken);
  //             setConsentURL(clmData.consentUrl);
  //             setOpenModal(true);
  //             return null;
  //           }
  //           else if (clmData.consentGiven) {
  //             setUser({
  //               email: data.response.data.emailAddress,
  //               refreshToken: res.refreshToken,
  //               userName: tokenDetails.name,
  //               token: res.accessToken,
  //               access: data.response.data.access,
  //               role: data.response.data.role,
  //             });
  //             setAuthProvider("azure");
  //             return data;
  //           }
  //         })
  //         .then((data: any) => {
  //           setIsLoading(false);
  //           if (data) {
  //             setTimeout(() => {
  //               if (data.response && data.response.data.role) {
  //                 console.log(data.response.data.role)
  //                 if(data.response.data.role == "LOA_REVIEWER" || data.response.data.role == "LOA_CREATOR"){
  //                   window.location.pathname = `/loa`;
  //                 }else if(data.response.data.role == "CONTRACT_REVIEWER" || data.response.data.role == "CONTRACT_CREATOR"){
  //                   window.location.pathname = `/contracts`;
  //                 }
  //                 else {
  //                   window.location.pathname = `/dashboard`;
  //                 }
  //               }
  //             }, 1000);
  //           }
  //         })
  //         .catch(() => {
  //           setIsLoading(false);
  //           openToast({ content: "Something went wrong!", type: "error" });
  //         });
  //     })
  //
  //     .catch((e) => {
  //       setIsLoading(false);
  //       openToast({ content: e, type: "error" });
  //     });
  // };

  const sendEmail = (accessToken: string) => {
    axios
      .get(`${apiBaseUrl}/userprofile/consent-email/to-user`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-Auth-Provider": "azure",
        },
      })
      .then(({ data }: any) => {
        // console.log("data", data);
      });
  };

  return (
    <>
      <UserConsent
        active={isActive}
        openModal={openModal}
        consentURL={consentURL}
        setOpenModal={(val) => setOpenModal(val)}
      />
      {/*{reactAuthFlow === "BOTH" && (*/}
      {/*  <Button*/}
      {/*    size="large"*/}
      {/*    block*/}
      {/*    onClick={login}*/}
      {/*    loading={isLoading}*/}
      {/*  >*/}
      {/*    <Space*/}
      {/*      style={{*/}
      {/*        display: "flex",*/}
      {/*        justifyContent: "center",*/}
      {/*        alignItems: "center",*/}
      {/*      }}*/}
      {/*    >*/}
      {/*      <Image*/}
      {/*        src={MicroSoftLogo}*/}
      {/*        preview={false}*/}
      {/*      />*/}
      {/*      {<Typography.Text type="secondary">Login with Microsoft</Typography.Text>}*/}
      {/*    </Space>*/}
      {/*  </Button>*/}
      {/*)}*/}
      {reactAuthFlow === "AZURE" && (
        <Button
          style={{ border: "1px solid #29256E" }}
          size="large"
          type="ghost"
          block
          onClick={() => {
            setIsLoading(true);
            instance.loginRedirect(loginRequest);
          }}
          loading={isLoading || isSSOLoading}
        >
          <Space
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {/*<Image*/}
            {/*  src={MicroSoftLogo}*/}
            {/*  preview={false}*/}
            {/*/>*/}
            <Typography.Text style={{ color: "#29256E" }}>Login Using Staff AD</Typography.Text>
          </Space>
        </Button>
      )}
    </>
  );
};
